import { useTranslation } from '@mint-lib/i18n';
import { CloseOutline } from '@mint-lib/icons';
import { Card, typographyVariants } from '@mint-lib/tw-components';
import { Suggestions } from '@mint-sdk/api-recommendations';

import useSuggestionTimeRange from '../../../hooks/useSuggestionTimeRange.js';

type Props = {
  reason: Suggestions.SuggestionResponseType['reason'];
  date?: Suggestions.SuggestionResponseType['decisionTime'];
  decidedBy: Suggestions.SuggestionResponseType['decidedBy'];
};

const RejectReason = ({ reason, date, decidedBy }: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');
  const { timeRangeArray } = useSuggestionTimeRange({
    status: Suggestions.Statuses.REJECTED,
    decisionTime: date,
    expiredAt: null,
    reworkDate: null,
  });
  const [num, range] = timeRangeArray;

  const fullName = decidedBy
    ? `${decidedBy.firstName} ${decidedBy.lastName}`
    : '';

  const rejectInfo = t(`{{val, relativetime}} by {{name}}`, {
    name: fullName,
    val: -num,
    range,
  });

  return (
    <Card
      color="warning"
      variant="outlined"
      className="flex w-full"
      contentClassName="flex w-full flex-col gap-3"
    >
      <div className="flex w-full flex-row justify-between">
        <div className="flex w-full items-center gap-2">
          <CloseOutline className="fill-warning-main" />
          <p
            className={typographyVariants({ variant: 'h6', color: 'warning' })}
          >
            {t('Reject reason')}
          </p>
        </div>
        <div className="flex w-full justify-end">
          <p
            className={typographyVariants({
              variant: 'caption1',
              color: 'secondary',
            })}
          >
            {rejectInfo}
          </p>
        </div>
      </div>
      <div
        className={typographyVariants({
          variant: 'bodyLong01',
        })}
      >
        {reason}
      </div>
    </Card>
  );
};

export default RejectReason;
